export default __webpack_public_path__ + "static/media/email.d47a7f95.svg";